import { useSelector } from "react-redux"
import { getTranslated } from "../../utils/CommonUtils"
import UMCButton from "./UMCButton"

const UMCDomainContentLayout = (props) => {
    
    const dict = useSelector(state => state.common.dict)

    return <div className="content-layout">

        <div className="body-content">
            {props.header ? <div className="sl-header">
                {props.header}
            </div> : <></>}
            {props.domains}
        </div>
        <div className="sl-footer">
            <span className="mandatory-info error-status-txt">* {getTranslated(dict, "MSG_MANDATORY_FIELD")}</span>
            <UMCButton
                className="footer-back-btn"
                label={props.backBtnLabel || "LABEL_BACK"}
                disabled={props.disablBackBtn || false}
                onClick={() => props.goBackHandler && props.goBackHandler(true)}
            />
            {props.isReadOnly ? <></> : <UMCButton
                label={props.okBtnLabel || "LABEL_CREATE"}
                disabled={props.disablOKBtn || false}
                onClick={() => props.handleOK && props.handleOK()}
                type="primary"
            />}
        </div>
    </div>
}

export default UMCDomainContentLayout